
export default [

  {
    path: '/owner',
    name: 'owner',
    component: () => import('@/views/app/owner'),
    meta:{
      authRequired:true,
      role: 'OWNER'
    },
    children:[    
      {
        path: 'house-rental',
        name:'houseOwner',
        component: () => import('@/views/app/owner/house-rental/index.vue'),
        children: [
          {
            path: 'add',
            component: () => import('@/views/app/owner/house-rental/add.vue')
          },
          {
            path: 'list',
            component: () => import('@/views/app/owner/house-rental/list.vue')
          }
        ]
      },
      {
        path: 'house-sale',
        component: () => import('@/views/app/owner/house-sale'),
        children: [
          {
            path: 'add',
            component: () => import('@/views/app/owner/house-sale/add.vue')
          },
          {
            path: 'list',
            component: () => import('@/views/app/owner/house-sale/list.vue')
          }
        ]
      }
    ]
  },
  {
    path: 'become-a-owner',
    component: () => import('@/views/app/owner/become-owner'),
    meta:{
      authRequired:true
    }
  }
]